export const routes = {
  mostPopular: "/",
  movieDetails: "/movie",
};
